import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BlogService } from '../../../services/blog.service';
import { PostI } from '../../../shared/post.interface';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.scss']
})
export class NewComponent implements OnInit {

  iframe: string;
  image: any;
  imageSrc: any;
  parrafo: string;
  content: any = [];
  video: boolean;

  constructor(private blogSvc: BlogService,
              private router: Router) { }

  newPostForm = new FormGroup ({
    titulo: new FormControl('', Validators.required),
    introduccion: new FormControl('', Validators.required),
    contenido: new FormControl('', Validators.required),
    fecha: new FormControl(new Date().getTime()),
  });

  ngOnInit(): void {
  }

  imagen(){
    this.video = false
  }

  videoIn(){
    this.video = true;
  }

  nuevoParrafo(){
    this.content.push(this.parrafo);
    console.log(this.content);
    this.newPostForm.patchValue({
      contenido: ''
    });

  }

  asignarVideo(video: string){
    this.iframe = video;
  }

  addPost(post: PostI){
    post.contenido = this.content;
    if (this.video) {
      post.video = 'Si';
      post.imagen = this.iframe;
    }
    if (!this.video) {
      post.video = 'No';
    }
    console.log(post);

    /* if ( this.newPostForm.invalid ) {
      Swal.fire({
        title: 'Error...',
        text: 'Debe ingresar la información requerida',
        icon: 'error',
        allowOutsideClick: false,
        showCloseButton: true
      });
      return Object.values( this.newPostForm.controls ).forEach( control => {
        if ( control instanceof FormGroup ) {
          // tslint:disable-next-line: no-shadowed-variable
          Object.values( control.controls ).forEach( control => control.markAsTouched() );
        } else {
          control.markAsTouched();
        }
      });
    } */
    if (!this.video) {
      this.blogSvc.filterPost(post, this.image);
      Swal.fire({
        title: 'Blog publicado',
        text: 'Creado satisfactoriamente',
        icon: 'success',
        showCloseButton: true
      });
    }
    if (this.video) {
      this.blogSvc.agregarPostWithVideo(post);
      Swal.fire({
        title: 'Blog publicado',
        text: 'Creado satisfactoriamente',
        icon: 'success',
        showCloseButton: true
      });
    }
    this.router.navigate(['/listaPost']);
  }

  handleImage(event: any){
    this.image = event.target.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      this.imageSrc = reader.result;
    };
    reader.readAsDataURL(this.image);
  }


}
